[
  {
    "slug": "kickoff",
    "name": "Kickoff",
    "tagline": "Plan now, build later",
    "description": "Runs a planning-only session that produces CLAUDE.md, a plan file, and a ready-to-paste build prompt for session 2. Asks clarifying questions, explores the codebase, and outputs everything you need to hand off to a build session.",
    "category": "workflow",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["kickoff", "new project", "start a project", "plan a feature", "plan this out"],
    "example": "/kickoff → asks questions about goals and constraints → writes CLAUDE.md + plan.md + build prompt",
    "install": "mkdir -p ~/.claude/skills/kickoff && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/kickoff/skill.md -o ~/.claude/skills/kickoff/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/kickoff",
    "featured": true
  },
  {
    "slug": "build",
    "name": "Build",
    "tagline": "Execute the plan, no questions asked",
    "description": "Use for session 2 after /kickoff. Reads plan.md and CLAUDE.md, then implements all steps in order without asking questions. Makes reasonable decisions and keeps moving until the build is complete.",
    "category": "workflow",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["build", "start building", "implement the plan", "build session", "execute the plan"],
    "example": "/build → reads plan.md → implements step by step → reports when done",
    "install": "mkdir -p ~/.claude/skills/build && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/build/skill.md -o ~/.claude/skills/build/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/build",
    "featured": false
  },
  {
    "slug": "resume",
    "name": "Resume",
    "tagline": "Pick up where you left off",
    "description": "Reads CLAUDE.md, git log, git status, git diff, and TODO/FIXME markers to summarize what was being worked on, the current state, and the obvious next step. Perfect for starting a new session on an existing project.",
    "category": "workflow",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["resume", "where did I leave off", "what was I working on", "pick up where I left off", "continue working"],
    "example": "/resume → reads project state → \"You were implementing the search feature. Step 3 of 5 is done. Next: add filter pills.\"",
    "install": "mkdir -p ~/.claude/skills/resume && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/resume/skill.md -o ~/.claude/skills/resume/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/resume",
    "featured": false
  },
  {
    "slug": "checkpoint",
    "name": "Checkpoint",
    "tagline": "Save progress, preview, and push",
    "description": "Mid-build save and preview. Runs type checks, sanity checks, git push, starts a local server, and takes a screenshot so you can see progress without breaking flow.",
    "category": "deploy",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["checkpoint", "save progress", "let me see it", "preview", "midpoint save", "how does it look"],
    "example": "/checkpoint → type checks pass → git push → serves at localhost:3000 → takes screenshot",
    "install": "mkdir -p ~/.claude/skills/checkpoint && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/checkpoint/skill.md -o ~/.claude/skills/checkpoint/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/checkpoint",
    "featured": false
  },
  {
    "slug": "shipit",
    "name": "Ship It",
    "tagline": "15-check audit, then deploy",
    "description": "Full deploy pipeline — runs a 15-check audit with auto-fix, then commits, pushes, and deploys to Cloudflare Pages. The last step before your project goes live.",
    "category": "deploy",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["ship it", "shipit", "deploy", "ready to deploy", "pre-deploy", "before I push", "ready to ship"],
    "example": "/shipit → 15 checks (entry point, git, meta tags, links...) → auto-fixes 3 issues → deploys to Cloudflare Pages",
    "install": "mkdir -p ~/.claude/skills/shipit && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/shipit/skill.md -o ~/.claude/skills/shipit/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/shipit",
    "featured": true
  },
  {
    "slug": "verify",
    "name": "Verify",
    "tagline": "14-category quality gate",
    "description": "Automated quality gate — checks 14 categories of objective criteria after a build, auto-fixes issues in a loop, and proves the build is clean. Run this after /build to catch problems before deploying.",
    "category": "quality",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["verify", "check my work", "quality gate", "did I pass", "run verification"],
    "example": "/verify → checks responsive layout, console errors, links, accessibility → auto-fixes 2 issues → all 14 categories pass",
    "install": "mkdir -p ~/.claude/skills/verify && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/verify/skill.md -o ~/.claude/skills/verify/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/verify",
    "featured": true
  },
  {
    "slug": "review",
    "name": "Review",
    "tagline": "Comprehensive site quality audit",
    "description": "Checks your site against 12 categories: broken links, SEO, layout, typography, copy, mobile, performance, visual polish, interactions, security, and code quality. Auto-fixes what it can.",
    "category": "quality",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["review", "launch ready", "pre-launch checklist", "quality audit", "SEO tags", "broken links", "security audit"],
    "example": "/review → finds 8 issues (missing meta tags, low contrast text, broken link) → fixes 5 automatically → reports remaining 3",
    "install": "mkdir -p ~/.claude/skills/review && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/review/skill.md -o ~/.claude/skills/review/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/review",
    "featured": false
  },
  {
    "slug": "roast",
    "name": "Roast",
    "tagline": "Quick 10-persona tech review",
    "description": "Quick tech review — 10 engineering personas (security, performance, UX, code quality, DevOps, API, accessibility, data, architecture, QA) each give a grade and their top findings in a single pass. Auto-fixes objective issues.",
    "category": "quality",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["roast", "quick review", "grade my project", "rate my code", "critique this"],
    "example": "/roast → Security: B+ (1 issue), Performance: A-, UX: B (3 issues)... → auto-fixes 4 objective issues",
    "install": "mkdir -p ~/.claude/skills/roast && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/roast/skill.md -o ~/.claude/skills/roast/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/roast",
    "featured": false
  },
  {
    "slug": "expert-panel",
    "name": "Expert Panel",
    "tagline": "150-finding multi-round executive review",
    "description": "Intensive multi-round expert review — 10 executive personas each do 3 rounds of critique with 5 fixes per round (150 findings total), followed by a 30-fix anti-AI text audit. The most thorough review skill available.",
    "category": "quality",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["expert panel", "executive review", "deep review", "multi-round review", "comprehensive critique"],
    "example": "/expert-panel → Round 1: 50 findings, 30 fixed → Round 2: 50 more → Round 3: 50 more → anti-AI text audit",
    "install": "mkdir -p ~/.claude/skills/expert-panel && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/expert-panel/skill.md -o ~/.claude/skills/expert-panel/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/expert-panel",
    "featured": false
  },
  {
    "slug": "beta-test",
    "name": "Beta Test",
    "tagline": "End-to-end QA with Playwright",
    "description": "Tests a web app end-to-end as a real user — navigates every page with Playwright, fills forms, tests interactions, catches bugs (console errors, broken i18n, dead links, CSP issues), produces a structured report with severity scores, then triages and fixes findings one by one.",
    "category": "quality",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["beta test", "test the app", "QA the site", "test the full pipeline", "walk through the app"],
    "example": "/beta-test → navigates 12 pages → finds 5 bugs (2 critical, 3 minor) → fixes all 5 → re-tests → clean",
    "install": "mkdir -p ~/.claude/skills/beta-test && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/beta-test/skill.md -o ~/.claude/skills/beta-test/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/beta-test",
    "featured": false
  },
  {
    "slug": "test-feature",
    "name": "Test Feature",
    "tagline": "Verify a specific feature works",
    "description": "Tests if a specific feature or function works as designed — explores the code, builds a test plan, runs tests, diagnoses and fixes failures in a loop, and reports results.",
    "category": "quality",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["test this feature", "verify it works", "does it work", "check if it's working", "run tests for"],
    "example": "/test-feature search → explores search code → tests 5 scenarios → 1 fails (empty query) → fixes → all pass",
    "install": "mkdir -p ~/.claude/skills/test-feature && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/test-feature/skill.md -o ~/.claude/skills/test-feature/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/test-feature",
    "featured": false
  },
  {
    "slug": "frontend-design",
    "name": "Frontend Design",
    "tagline": "Production-grade UI that doesn't look AI-generated",
    "description": "Builds web components, pages, or apps from scratch with distinctive, production-grade frontend code that avoids generic AI aesthetics. Produces polished results with intentional design choices.",
    "category": "design",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["build a page", "create a component", "build a landing page", "make a dashboard", "design a UI", "make it look good"],
    "example": "/frontend-design hero section → proposes 3 design vibes → builds chosen style with Tailwind + custom animations",
    "install": "mkdir -p ~/.claude/skills/frontend-design && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/frontend-design/skill.md -o ~/.claude/skills/frontend-design/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/frontend-design",
    "featured": true
  },
  {
    "slug": "design-match",
    "name": "Design Match",
    "tagline": "Match your site to a reference design",
    "description": "Analyzes a reference design's visual weight (structure, density, colors), extracts measured values, and iterates section-by-section with 1-5 scoring until your site is near-identical to the target.",
    "category": "design",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["make it look like", "design inspiration", "match this template", "my UI looks generic", "it looks vibe-coded"],
    "example": "/design-match [reference URL] → extracts spacing, colors, typography → iterates 3 rounds → score: 4.5/5",
    "install": "mkdir -p ~/.claude/skills/design-match && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/design-match/skill.md -o ~/.claude/skills/design-match/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/design-match",
    "featured": false
  },
  {
    "slug": "ui-ux-pro-max",
    "name": "UI/UX Pro Max",
    "tagline": "67 styles, 96 palettes, 13 stacks",
    "description": "UI/UX design toolkit with 67 styles, 96 palettes, 57 font pairings, 25 chart types, and 13 framework stacks including React, Next.js, Vue, Svelte, and SwiftUI. Can plan, build, review, and optimize.",
    "category": "design",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["UI design", "UX review", "color palette", "font pairing", "design system"],
    "example": "/ui-ux-pro-max review → audits color, typography, spacing, interactions → suggests 12 improvements with code",
    "install": "mkdir -p ~/.claude/skills/ui-ux-pro-max && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/ui-ux-pro-max/skill.md -o ~/.claude/skills/ui-ux-pro-max/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/ui-ux-pro-max",
    "featured": false
  },
  {
    "slug": "tdd-ui",
    "name": "TDD UI",
    "tagline": "Screenshot-driven visual testing",
    "description": "Takes a before screenshot, makes the UI edit, takes an after screenshot, evaluates the result, and gives a pass/fail verdict. Test-driven development for visual changes.",
    "category": "design",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["tdd ui", "screenshot before and after", "visual test", "does this look right", "visual diff"],
    "example": "/tdd-ui change button color → before screenshot → edits CSS → after screenshot → compares → pass",
    "install": "mkdir -p ~/.claude/skills/tdd-ui && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/tdd-ui/skill.md -o ~/.claude/skills/tdd-ui/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/tdd-ui",
    "featured": false
  },
  {
    "slug": "research",
    "name": "Research",
    "tagline": "Web research to markdown reports",
    "description": "Researches any topic by searching the web, reading local files, and writing focused markdown reports to a folder. Great for exploring new technologies, comparing options, or investigating issues.",
    "category": "content",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["research", "look into", "what are people saying about", "do a deep dive on", "investigate"],
    "example": "/research best auth libraries for Next.js → searches web → reads docs → writes comparison report",
    "install": "mkdir -p ~/.claude/skills/research && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/research/skill.md -o ~/.claude/skills/research/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/research",
    "featured": false
  },
  {
    "slug": "scrape",
    "name": "Scrape",
    "tagline": "Scrape, ingest, index, tag",
    "description": "Scrapes websites, ingests local files/PDFs/YouTube into a corpus, builds a search index, and auto-tags content. Useful for building knowledge bases or collecting structured data.",
    "category": "content",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["scrape", "crawl", "ingest", "build corpus", "build index"],
    "example": "/scrape https://example.com → crawls 50 pages → extracts text → builds searchable corpus",
    "install": "mkdir -p ~/.claude/skills/scrape && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/scrape/skill.md -o ~/.claude/skills/scrape/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/scrape",
    "featured": false
  },
  {
    "slug": "translate",
    "name": "Translate",
    "tagline": "English/Chinese translation with Bible support",
    "description": "Translates content between English and Chinese. Supports Bible verses (和合本 CUV), UI strings, and general text. Returns structured output with original and translated text.",
    "category": "content",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["translate", "translate to Chinese", "translate to English", "Chinese translation"],
    "example": "/translate \"God is love\" → 神就是爱 (1 John 4:8, 和合本)",
    "install": "mkdir -p ~/.claude/skills/translate && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/translate/skill.md -o ~/.claude/skills/translate/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/translate",
    "featured": false
  },
  {
    "slug": "last30days",
    "name": "Last 30 Days",
    "tagline": "What people are saying right now",
    "description": "Researches what people are saying about a topic in the last 30 days — searches Reddit, X/Twitter, and the web for current discussions, recommendations, and debates, then produces a structured briefing.",
    "category": "content",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["last 30 days", "recent discussions", "what are people saying about", "current sentiment", "reddit says"],
    "example": "/last30days Claude Code → finds 45 discussions → sentiment: 82% positive → top complaints: context limits, pricing",
    "install": "mkdir -p ~/.claude/skills/last30days && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/last30days/skill.md -o ~/.claude/skills/last30days/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/last30days",
    "featured": false
  },
  {
    "slug": "learn",
    "name": "Learn",
    "tagline": "Save learnings to persistent memory",
    "description": "Reflects on the conversation and updates memory — scans for learnings across 7 categories, updates auto-memory, CLAUDE.md, and Obsidian vault. Can run anytime mid-session to capture what you've learned.",
    "category": "learning",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["learn", "what did you learn", "save what you learned", "remember this", "update claude.md"],
    "example": "/learn → scans conversation → saves 3 feedback memories, updates CLAUDE.md with new convention",
    "install": "mkdir -p ~/.claude/skills/learn && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/learn/skill.md -o ~/.claude/skills/learn/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/learn",
    "featured": false
  },
  {
    "slug": "showcase",
    "name": "Showcase",
    "tagline": "Generate demo videos and scripts",
    "description": "Creates instructional videos or demo materials for completed projects — generates scripts, pushes to NotebookLM, and produces steering prompts for Video Overview generation.",
    "category": "learning",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["showcase", "create a video for", "instructional video", "demo video", "present this project"],
    "example": "/showcase → reads codebase → generates 3-minute script → pushes to NotebookLM → outputs video steering prompt",
    "install": "mkdir -p ~/.claude/skills/showcase && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/showcase/skill.md -o ~/.claude/skills/showcase/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/showcase",
    "featured": false
  },
  {
    "slug": "brief",
    "name": "Brief",
    "tagline": "Project briefing PDF in one command",
    "description": "Generates a project briefing PDF for sharing with colleagues. Reads the codebase, takes live screenshots, produces a PRD, and converts to PDF — all automatically.",
    "category": "learning",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["brief", "briefing", "generate PRD", "project PDF", "share with colleagues", "project summary"],
    "example": "/brief → reads code + screenshots → writes PRD → converts to PDF → saves to project folder",
    "install": "mkdir -p ~/.claude/skills/brief && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/brief/skill.md -o ~/.claude/skills/brief/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/brief",
    "featured": false
  },
  {
    "slug": "notebooklm",
    "name": "NotebookLM",
    "tagline": "Push files to Google NotebookLM",
    "description": "Pushes local markdown files into Google NotebookLM and generates deliverables — briefings, podcasts, mind maps, flashcards, study guides, and FAQs. All free, all automated.",
    "category": "learning",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["push to notebooklm", "send to notebooklm", "create a notebook from", "generate a podcast from", "make flashcards from"],
    "example": "/notebooklm → selects 5 markdown files → uploads to NotebookLM → generates podcast + mind map",
    "install": "mkdir -p ~/.claude/skills/notebooklm && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/notebooklm/skill.md -o ~/.claude/skills/notebooklm/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/notebooklm",
    "featured": false
  },
  {
    "slug": "ytr",
    "name": "YouTube Research",
    "tagline": "YouTube to NotebookLM pipeline",
    "description": "Searches YouTube for videos, pushes them into a Google NotebookLM notebook, runs AI analysis, and generates deliverables (infographics, podcasts, flashcards, mind maps, slide decks, study guides) — all in one command.",
    "category": "learning",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["research YouTube", "find videos and analyze", "yt-to-notebooklm", "search YouTube and summarize"],
    "example": "/ytr \"Claude Code tutorials\" → finds 10 videos → uploads to NotebookLM → generates podcast + flashcards",
    "install": "mkdir -p ~/.claude/skills/ytr && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/ytr/skill.md -o ~/.claude/skills/ytr/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/ytr",
    "featured": false
  },
  {
    "slug": "refactor",
    "name": "Refactor",
    "tagline": "Clean up code systematically",
    "description": "Improves code quality — tackles duplicated code, naming, readability, dead code, efficiency, and general cleanup. Analyzes before changing, explains trade-offs.",
    "category": "utility",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["refactor", "clean up this code", "simplify", "reduce complexity", "DRY", "code smell", "hard to read"],
    "example": "/refactor src/utils.ts → finds 3 duplicated patterns → consolidates into shared helpers → reduces 180 lines to 95",
    "install": "mkdir -p ~/.claude/skills/refactor && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/refactor/skill.md -o ~/.claude/skills/refactor/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/refactor",
    "featured": false
  },
  {
    "slug": "google-forms",
    "name": "Google Forms",
    "tagline": "Build forms with Apps Script",
    "description": "Creates or edits Google Forms programmatically — generates Apps Script code to build forms. Never uses the Forms UI, always injects code via the Apps Script editor.",
    "category": "utility",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["create a form", "set up a survey", "google form", "questionnaire", "feedback form", "Apps Script form"],
    "example": "/google-forms feedback survey → generates Apps Script → 10 questions with validation + email collection",
    "install": "mkdir -p ~/.claude/skills/google-forms && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/google-forms/skill.md -o ~/.claude/skills/google-forms/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/google-forms",
    "featured": false
  },
  {
    "slug": "playwright-cli",
    "name": "Playwright CLI",
    "tagline": "Browser automation from the terminal",
    "description": "Automates browser interactions — navigating to URLs, taking screenshots, filling forms, clicking buttons, extracting data, and generating PDFs. All from the command line.",
    "category": "utility",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["navigate to", "take screenshot of website", "fill form", "browser automation", "open browser", "save as PDF"],
    "example": "/playwright-cli screenshot https://example.com → opens browser → takes full-page screenshot → saves to project",
    "install": "mkdir -p ~/.claude/skills/playwright-cli && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/playwright-cli/skill.md -o ~/.claude/skills/playwright-cli/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/playwright-cli",
    "featured": false
  },
  {
    "slug": "skill-creator",
    "name": "Skill Creator",
    "tagline": "Create and test new skills",
    "description": "Creates new skills, modifies existing ones, runs skill evals, benchmarks performance, and optimizes skill descriptions. The meta-skill for building skills.",
    "category": "utility",
    "author": "Z Huang",
    "authorGithub": "Joshli316",
    "triggers": ["create a skill", "modify a skill", "run evals", "new skill", "edit skill", "test skill"],
    "example": "/skill-creator deploy-check → writes skill.md → runs 3 eval scenarios → optimizes trigger description",
    "install": "mkdir -p ~/.claude/skills/skill-creator && curl -sL https://raw.githubusercontent.com/Joshli316/Skill-Marketplace/main/skills/skill-creator/skill.md -o ~/.claude/skills/skill-creator/skill.md",
    "sourceUrl": "https://github.com/Joshli316/Skill-Marketplace/tree/main/skills/skill-creator",
    "featured": false
  }
]
